import { TLink } from "../../../types";
import DesktopHeader from "./desktop-components/desktop-header/desktop-header";
import MobileHeader from "./mobile-components/mobile-header/mobile-header";

export type THeaderV2Props = {
  menuItems: Array<THeaderV2Category>;
  featureLinks: Array<TFeatureLink>;
  mobileHeaderLinks?: Array<TLink>;
  isMobile?: boolean;
  logoUrl: string;
  isFullscreenPage?: boolean;
  disableBoxShadowMobile?: boolean;
};

export type TDatoPage = {
  id: string;
  title: string;
  slug: string;
};

export type TFeatureLink = {
  title: string;
  url: string;
  icon?: string;
};

export type THeaderV2Category = {
  title: string;
  url?: string;
  links?: Array<TLink>;
};

export const HeaderV2 = (props: THeaderV2Props) => {
  return (
    <header>
      <DesktopHeader {...props} />
      <MobileHeader {...props} />
    </header>
  );
};

export default HeaderV2;
